export default {
  nav_home: 'INICIO',
  nav_about: 'NOSOTROS',
  nav_services: 'SERVICIOS',
  nav_contact: 'CONTACTO',
  nav_call_us: 'Ll\u00E1manos',
  nav_get_quote: 'Cotizar',
  nav_menu: 'Men\u00FA',

  footer_company_desc: 'FMO LLC se especializa en soluciones de aislamiento de alta calidad para propiedades residenciales y comerciales en Lafayette, Indiana y comunidades cercanas. M\u00E1s de 15 a\u00F1os de experiencia mejorando la eficiencia energ\u00E9tica y el confort interior.',
  footer_phone: '(574) 721-9810',
  footer_email: 'miguelceo@fmoinsulation.com',
  footer_navigation: 'Navegaci\u00F3n',
  footer_nav_home: 'Inicio',
  footer_nav_services: 'Servicios',
  footer_nav_about: 'Nosotros',
  footer_nav_contact: 'Contacto',
  footer_our_services: 'Nuestros Servicios',
  footer_service_spray_foam: 'Aislamiento de Espuma Spray',
  footer_service_batt: 'Aislamiento en Paneles (Batt)',
  footer_service_cellulose: 'Aislamiento de Celulosa',
  footer_service_attic: 'Aislamiento de \u00C1tico',
  footer_service_walls: 'Aislamiento de Paredes',
  footer_service_crawl: 'Aislamiento de S\u00F3tano',
  footer_contact: 'Contacto',
  footer_address_line1: 'PO Box 4742',
  footer_address_line2: 'Lafayette, IN 47903',
  footer_hours_title: 'Horario de Atenci\u00F3n',
  footer_hours_weekdays: 'Lun - Vie: 8:00 AM - 7:00 PM',
  footer_hours_weekends: 'S\u00E1b - Dom: 9:00 AM - 6:00 PM',
  footer_copyright: '\u00A9 2026 FMO LLC Servicios de Aislamiento. Todos los derechos reservados.',
  footer_serving: 'Sirviendo a Lafayette, Indiana y comunidades cercanas.',

  common_read_more: 'Conoce M\u00E1s',
  common_learn_more: 'Conoce M\u00E1s Sobre Nosotros',
  common_view_all: 'Ver Todos',
  common_request_quote: 'Solicitar Presupuesto Gratis',
  common_request_this_service: 'Solicitar Este Servicio',
  common_free_estimate: 'Estimados Gratis',
  common_free_estimates: 'Presupuestos Disponibles',
  common_send: 'Enviar',
  common_sending: 'Enviando...',
  common_success: '\u00A1Solicitud enviada!',
  common_success_contact: 'Te contactaremos pronto.',
  common_success_24h: 'Te contactaremos dentro de 24 horas.',
  common_send_another: 'Enviar otra solicitud',
  common_error: 'Ocurri\u00F3 un error. Intenta de nuevo.',
  common_error_spam: 'Tu mensaje fue marcado como spam. Por favor intenta de nuevo.',
  common_error_connection: 'Error de conexi\u00F3n. Intenta de nuevo.',
  common_years_experience: 'A\u00F1os de Experiencia',
  common_satisfaction_guaranteed: 'Satisfacci\u00F3n Garantizada',
  common_local: 'Negocio Familiar',
  common_scroll: 'Despl\u00E1zate',
  common_name: 'Nombre',
  common_full_name: 'Nombre Completo',
  common_first_name: 'Nombre',
  common_last_name: 'Apellido',
  common_email: 'Correo Electr\u00F3nico',
  common_phone: 'N\u00FAmero de Tel\u00E9fono',
  common_address: 'Direcci\u00F3n de la Propiedad',
  common_service_needed: 'Servicio Necesario',
  common_message: 'Mensaje / Comentarios',
  common_select_service: 'Selecciona un servicio',
  common_required: 'Requerido',
  general_consultation: 'Consulta General',
  spray_foam: 'Aislamiento de Espuma Spray',
  batt_insulation: 'Aislamiento en Paneles (Batt)',
  roll_insulation: 'Aislamiento en Rollos',
  cellulose_insulation: 'Aislamiento de Celulosa',
  blown_in_insulation: 'Aislamiento Soplado',
  attic_insulation: 'Aislamiento de \u00C1tico',
  wall_insulation: 'Aislamiento de Paredes',
  crawl_space_insulation: 'Aislamiento de S\u00F3tano',
  metal_building_insulation: 'Aislamiento para Edificios Met\u00E1licos',
  spray_foam_closed: 'Espuma Spray Celda Cerrada',
  spray_foam_open: 'Espuma Spray Celda Abierta',
};